module.exports = __webpack_public_path__ + "img/tongdian1@2x.d8ceb592.png";